"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const translationContext_1 = require("configs/translationContext");
const ExpirationDate = ({ dripping }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    if (dripping.expirationDays) {
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('dripping_2.columns.expiration.days_after_release', {
                amountToPluralize: dripping.expirationDays,
                data: { value: dripping.expirationDays }
            }) }));
    }
    return ((0, jsx_runtime_1.jsx)("span", { className: "_text-gray-400", children: t('dripping_2.columns.expiration.do_not_expire') }));
};
exports.default = ExpirationDate;
